import { api } from "./api";

const BASE_URL = "/cooperacao";

export default class cooperacaoService {
  static get = async (params) => {
    try {
      const { data } = await api.get(BASE_URL, { params });
      return data;
    } catch (error) {
      console.error("Erro /cooperacao:", error);
      throw error;
    }
  };

  static post = async (payload) => {
    try {
      const { data } = await api.post(BASE_URL, payload);
      return data;
    } catch (error) {
      console.error("Erro POST /cooperacao:", error);
      throw error;
    }
  };

  static comment = async (id, payload) => {
    try {
      const { data } = await api.post(`${BASE_URL}/${id}/comment`, payload);
      return data;
    } catch (error) {
      console.error(`Erro POST /cooperacao/${id}/comment:`, error);
      throw error;
    }
  };

  static like = async (id) => {
    try {
      const { data } = await api.post(`${BASE_URL}/${id}/like`);
      return data;
    } catch (error) {
      console.error(`Erro POST /cooperacao/${id}/like:`, error);
      throw error;
    }
  };

  static reuse = async (id) => {
    try {
      const { data } = await api.post(`${BASE_URL}/${id}/reuse`);
      return data;
    } catch (error) {
      console.error(`Erro POST /cooperacao/${id}/reuse:`, error);
      throw error;
    }
  };
}
